export default __webpack_public_path__ + "static/media/view-result.32c88495.svg";